export default __webpack_public_path__ + "static/media/boost-01.61612095.jpg";